import React, { useState, useEffect } from "react";

import { connect, useDispatch, useSelector } from "react-redux";
import { Table, Tag, Drawer, Collapse, Tabs } from "antd";
import { ResponsiveContainer, AreaChart, Area, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip as ChartTooltip, Legend } from "recharts";
import ReactStars from "react-stars";
// import "antd/dist/antd.css";
// import { itemRender, onShowSizeChange } from "../../paginationfunction";

import { Link } from "react-router-dom";
import { EditInfo, DeleteModal } from ".";
import { apiURL } from "../../utils/config";
// import { getCourseOwners } from "../../appRedux/actions/courseOwners";
import { Avatar_02 } from "../../Routes/ImagePath";
import moment from "moment";
import { currencyConverter } from "../../utils/currency";
import { getPlatformsList } from "../../appRedux/actions/platforms";
import SubscriptionListView from "../Subscriptions/ListView";



const getPlatformMockAnalytics = (code) => {
  const cleanCode = String(code || "").trim().toLowerCase();
  switch (cleanCode) {
    case "udemy":
      return {
        courses: 412,
        revenue: "₹1,84,300",
        clicks: 8420,
        conversionRate: "4.8%",
        chartData: [
          { name: "Week 1", Clicks: 1200, Impressions: 24000 },
          { name: "Week 2", Clicks: 1900, Impressions: 32000 },
          { name: "Week 3", Clicks: 2400, Impressions: 38000 },
          { name: "Week 4", Clicks: 2920, Impressions: 45000 },
        ],
        topCourses: [
          { title: "Complete Web Developer in 2026", clicks: 1450, sales: 82, conversion: "5.6%" },
          { title: "React - The Complete Guide", clicks: 1220, sales: 65, conversion: "5.3%" },
          { title: "Python Bootcamp Zero to Hero", clicks: 980, sales: 44, conversion: "4.5%" },
        ],
        insight: "Udemy Outbound clicks peaked on weekends. Outbound clicks on Development categories are up by 15%. Consider promoting Udemy coupon codes on the landing page.",
      };
    case "coursera":
      return {
        courses: 184,
        revenue: "₹4,12,000",
        clicks: 5210,
        conversionRate: "7.2%",
        chartData: [
          { name: "Week 1", Clicks: 900, Impressions: 18000 },
          { name: "Week 2", Clicks: 1100, Impressions: 21000 },
          { name: "Week 3", Clicks: 1500, Impressions: 26000 },
          { name: "Week 4", Clicks: 1710, Impressions: 29000 },
        ],
        topCourses: [
          { title: "Google Data Analytics Professional Certificate", clicks: 920, sales: 74, conversion: "8.0%" },
          { title: "AI For Everyone by Andrew Ng", clicks: 750, sales: 58, conversion: "7.7%" },
          { title: "Python for Everybody Specialization", clicks: 610, sales: 41, conversion: "6.7%" },
        ],
        insight: "Coursera Plus subscription clicks have a 7.2% conversion rate, compared to 2.8% for individual courses. Focus on marketing the Coursera Plus annual pricing option.",
      };
    case "edx":
    default:
      return {
        courses: 95,
        revenue: "₹92,400",
        clicks: 2840,
        conversionRate: "3.5%",
        chartData: [
          { name: "Week 1", Clicks: 500, Impressions: 12000 },
          { name: "Week 2", Clicks: 650, Impressions: 14000 },
          { name: "Week 3", Clicks: 790, Impressions: 15500 },
          { name: "Week 4", Clicks: 900, Impressions: 17000 },
        ],
        topCourses: [
          { title: "Harvard CS50's Introduction to Computer Science", clicks: 450, sales: 21, conversion: "4.6%" },
          { title: "MITx Introduction to Computer Science and Programming", clicks: 310, sales: 12, conversion: "3.8%" },
          { title: "Data Science Specialization by HarvardX", clicks: 240, sales: 8, conversion: "3.3%" },
        ],
        insight: "Outbound affiliate clicks on Professional Certificates remain high but signups are slow. Recommend adding dynamic discounts or highlighting trials.",
      };
  }
};

function ListView(props) {
  const dispatch = useDispatch();
  const [selectedPlatform, setSelectedPlatform] = useState(null);
  const { platformList, queryInfo, totalRecords, selectedCurrency, currencyData } = useSelector(
    (state) => ({
      platformList: state.platforms.platformList,
      queryInfo: state.platforms.queryInfo,
      totalRecords: state.platforms.totalRecords,
      selectedCurrency: state.common.selectedCurrency,
      currencyData: state.common.currencyData,
    })
  );

  useEffect(() => {
    if (selectedPlatform) {
      document.body.classList.add("hide-sidebar-hub");
    } else {
      document.body.classList.remove("hide-sidebar-hub");
    }
    return () => {
      document.body.classList.remove("hide-sidebar-hub");
    };
  }, [selectedPlatform]);

  const handleTableChange = (pagination, filters, sorter) => {
    console.log({ pagination, filters, sorter });
    const { current, pageSize } = pagination;
    dispatch(
      getPlatformsList({
        ...queryInfo,
        page: current,
        size: pageSize,
      })
    );
  };

  const columns = [
    {
      title: "Platform Name",
      dataIndex: "name",
      align: "center",
      width: "45%",
      render: (name, record) => (
        <h2 className="table-avatar" style={{ textOverflow: "ellipsis", whiteSpace: "nowrap", justifyContent: "center" }}>
          <span 
            onClick={() => setSelectedPlatform(record)} 
            style={{ color: "#1890ff", cursor: "pointer", fontWeight: 500 }}
          >
            {name}
          </span>
        </h2>
      ),
    },

    {
      title: "Total Courses",
      dataIndex: "totalCourses",
      align: "center",
      width: "20%",
      render: (totalCourses) => totalCourses || 0,
    },
    {
      title: "Status",
      dataIndex: "isActive",
      align: "center",
      width: "20%",
      render: (isActive) => (
        <Tag color={isActive ? "success" : "error"} style={{ borderRadius: "4px" }}>
          {isActive ? "Active" : "Inactive"}
        </Tag>
      ),
    },
    {
      title: "Action",
      align: "center",
      width: "15%",
      render: (text, record) => (
        <div className="dropdown dropdown-action text-center">
          <Link
            to="#"
            className="action-icon dropdown-toggle"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i className="material-icons">more_vert</i>
          </Link>
          <div className="dropdown-menu dropdown-menu-right">
            <EditInfo info={record} key={"edit_info"} />
            <DeleteModal info={record} />
          </div>
        </div>
      ),
    },
  ];

  const itemRender = (_, type, originalElement) => {
    console.log(type, "a", originalElement);
    if (type === "prev") {
      return <a href="#!">Previous</a>;
    }
    if (type === "next") {
      return <a href="#!">Next</a>;
    }
    return originalElement;
  };

  return (
    <div className="row m-0 mt-3">
      <div className="col-md-12 p-0" id="table-responsive">
        <div className="table-responsive" id="setMinheight">
          <Table
            className="table-striped"
            pagination={{
              total: totalRecords,
              pageSizeOptions: ["5", "10", "20", "50"],
              showSizeChanger: true,
              showTotal: (total, range) => `Showing ${range[0]} to ${range[1]} of ${total} entries`,
              onShowSizeChange: (current, pageSize) => {
                console.log({ current, pageSize });
                dispatch(
                  getPlatformsList({
                    ...queryInfo,
                    page: current,
                    size: pageSize,
                  })
                );
              },
              itemRender: itemRender,
            }}
            onChange={(pagination, filters, sorter) =>
              handleTableChange(pagination, filters, sorter)
            }
            style={{ overflowX: "auto" }}
            columns={columns}
            dataSource={platformList}
            rowKey={(record) => record._id}
          />
        </div>
      </div>

      <Drawer
        title={<span style={{ fontSize: "20px", fontWeight: 700 }}>Platform Hub: {selectedPlatform?.name}</span>}
        placement="right"
        width="100%"
        zIndex={1000}
        onClose={() => setSelectedPlatform(null)}
        open={!!selectedPlatform}
      >
        {selectedPlatform && (() => {
          const analytics = getPlatformMockAnalytics(selectedPlatform.code);
          return (
            <Tabs defaultActiveKey="1" style={{ marginTop: "-12px" }}>
              <Tabs.TabPane tab="Details & FAQs" key="1">
                <div style={{ marginTop: "16px" }}>
                  <div style={{ marginBottom: "20px", borderBottom: "1px solid #f0f0f0", paddingBottom: "16px" }}>
                    <h3 style={{ margin: 0, fontWeight: 600, color: "#111827" }}>{selectedPlatform.name}</h3>
                    <p style={{ margin: "4px 0 0 0", color: "#6b7280" }}>Code: <strong>{selectedPlatform.code}</strong></p>
                    <div style={{ marginTop: "12px" }}>
                      <Tag color={selectedPlatform.isActive ? "success" : "error"}>
                        {selectedPlatform.isActive ? "Active" : "Inactive"}
                      </Tag>
                      <Tag color="cyan" style={{ marginLeft: "8px" }}>
                        Courses: {selectedPlatform.totalCourses || 0}
                      </Tag>
                    </div>
                  </div>
                  
                  <h4 style={{ fontWeight: 600, marginBottom: "12px", color: "#374151", fontSize: "14px" }}>Global Platform FAQs</h4>
                  {selectedPlatform.faqs && selectedPlatform.faqs.length > 0 ? (
                    <Collapse accordion style={{ background: "#f9fafb" }}>
                      {selectedPlatform.faqs.map((faq, idx) => (
                        <Collapse.Panel 
                          header={
                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%", paddingRight: "16px" }}>
                              <span style={{ fontWeight: 500 }}>{faq.question}</span>
                              {!faq.isActive && <Tag style={{ margin: 0 }}>Inactive</Tag>}
                            </div>
                          } 
                          key={idx}
                        >
                          <p style={{ margin: 0, color: "#4b5563", lineHeight: 1.5 }}>{faq.answer}</p>
                          {faq.priority ? <div style={{ fontSize: "11px", color: "#9ca3af", marginTop: "8px" }}>Priority: {faq.priority}</div> : null}
                        </Collapse.Panel>
                      ))}
                    </Collapse>
                  ) : (
                    <div style={{ padding: "24px 0", textAlign: "center", color: "#9ca3af" }}>
                      No FAQs defined at platform level.
                    </div>
                  )}
                </div>
              </Tabs.TabPane>
              <Tabs.TabPane tab="Analytics & Insights" key="2">
                <div style={{ marginTop: "16px" }}>
                  {/* KPI Cards */}
                  <div className="row g-2" style={{ marginBottom: "20px" }}>
                    <div className="col-6 col-md-3">
                      <div style={{ background: "#f9fafb", border: "1px solid #e5e7eb", borderRadius: "6px", padding: "10px", textAlign: "center" }}>
                        <div style={{ fontSize: "12px", color: "#6b7280" }}>Synced Courses</div>
                        <h4 style={{ margin: "4px 0 0 0", fontWeight: 700, color: "#111827" }}>{selectedPlatform.totalCourses || analytics.courses}</h4>
                      </div>
                    </div>
                    <div className="col-6 col-md-3">
                      <div style={{ background: "#f9fafb", border: "1px solid #e5e7eb", borderRadius: "6px", padding: "10px", textAlign: "center" }}>
                        <div style={{ fontSize: "12px", color: "#6b7280" }}>Outbound Clicks</div>
                        <h4 style={{ margin: "4px 0 0 0", fontWeight: 700, color: "#2563eb" }}>{analytics.clicks}</h4>
                      </div>
                    </div>
                    <div className="col-6 col-md-3">
                      <div style={{ background: "#f9fafb", border: "1px solid #e5e7eb", borderRadius: "6px", padding: "10px", textAlign: "center" }}>
                        <div style={{ fontSize: "12px", color: "#6b7280" }}>Est. Revenue</div>
                        <h4 style={{ margin: "4px 0 0 0", fontWeight: 700, color: "#059669" }}>{analytics.revenue}</h4>
                      </div>
                    </div>
                    <div className="col-6 col-md-3">
                      <div style={{ background: "#f9fafb", border: "1px solid #e5e7eb", borderRadius: "6px", padding: "10px", textAlign: "center" }}>
                        <div style={{ fontSize: "12px", color: "#6b7280" }}>Conversion Rate</div>
                        <h4 style={{ margin: "4px 0 0 0", fontWeight: 700, color: "#d97706" }}>{analytics.conversionRate}</h4>
                      </div>
                    </div>
                  </div>

                  {/* Chart */}
                  <div style={{ border: "1px solid #e5e7eb", borderRadius: "8px", padding: "16px", background: "#fff", marginBottom: "20px" }}>
                    <h5 style={{ fontWeight: 600, fontSize: "13px", color: "#374151", marginBottom: "12px" }}>Outbound Clickstream & Impressions Trend (Last 30 Days)</h5>
                    <ResponsiveContainer width="100%" height={180}>
                      <AreaChart data={analytics.chartData} margin={{ top: 5, right: 5, left: -20, bottom: 0 }}>
                        <defs>
                          <linearGradient id="colorClicks" x1="0" y1="0" x2="0" y2="1">
                            <stop offset="5%" stopColor="#2563eb" stopOpacity={0.2}/>
                            <stop offset="95%" stopColor="#2563eb" stopOpacity={0}/>
                          </linearGradient>
                        </defs>
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="name" style={{ fontSize: "10px" }} />
                        <YAxis style={{ fontSize: "10px" }} />
                        <ChartTooltip />
                        <Area type="monotone" dataKey="Clicks" stroke="#2563eb" fillOpacity={1} fill="url(#colorClicks)" strokeWidth={2} />
                      </AreaChart>
                    </ResponsiveContainer>
                  </div>

                  {/* Top Courses Leaderboard */}
                  <h5 style={{ fontWeight: 600, fontSize: "13px", color: "#374151", marginBottom: "12px" }}>Top Performing Courses</h5>
                  <div className="table-responsive" style={{ border: "1px solid #e5e7eb", borderRadius: "6px", marginBottom: "20px" }}>
                    <table className="table table-sm" style={{ margin: 0, fontSize: "12px" }}>
                      <thead>
                        <tr style={{ background: "#f9fafb" }}>
                          <th>Course Title</th>
                          <th style={{ textAlign: "center" }}>Clicks</th>
                          <th style={{ textAlign: "center" }}>Sales</th>
                          <th style={{ textAlign: "center" }}>CTR</th>
                        </tr>
                      </thead>
                      <tbody>
                        {analytics.topCourses.map((c, i) => (
                          <tr key={i}>
                            <td style={{ maxWidth: "220px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }} title={c.title}>
                              {c.title}
                            </td>
                            <td style={{ textAlign: "center", fontWeight: 600, color: "#2563eb" }}>{c.clicks}</td>
                            <td style={{ textAlign: "center", fontWeight: 600, color: "#059669" }}>{c.sales}</td>
                            <td style={{ textAlign: "center", color: "#d97706" }}>{c.conversion}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>

                  {/* AI/MS Clarity Strategic Insight */}
                  <div style={{ background: "#eff6ff", border: "1px solid #bfdbfe", borderRadius: "8px", padding: "14px", display: "flex", gap: "10px" }}>
                    <i className="fa fa-info-circle" style={{ color: "#2563eb", fontSize: "18px", marginTop: "2px" }} />
                    <div>
                      <strong style={{ display: "block", fontSize: "12px", color: "#1e3a8a", marginBottom: "4px" }}>Strategic Recommendation:</strong>
                      <p style={{ margin: 0, fontSize: "12px", color: "#1e40af", lineHeight: 1.5 }}>
                        {analytics.insight}
                      </p>
                    </div>
                  </div>
                </div>
              </Tabs.TabPane>
              <Tabs.TabPane tab="Subscriptions" key="3">
                <div style={{ marginTop: "16px" }}>
                  <SubscriptionListView merchantCode={selectedPlatform.code} />
                </div>
              </Tabs.TabPane>
            </Tabs>
          );
        })()}
      </Drawer>
    </div>
  );
}

export default ListView;
